import { useSelector } from 'react-redux';
import {
  AlloyButton,
  AlloyIcon,
  Popup,
  InlineLoader
} from 'cat-ecommerce-alloy';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import Conditional from '@app/components/common/Conditional';
import CoreDepositPopup from '@app/components/common/CoreDepositPopup';
import ContactDealerPopup from '@app/components/common/ContactDealerPopup';
import { useBreakpoint } from '@app/hooks';
import { PAGE_BREAKPOINTS } from '@app/constants/commonConstants';
import { CONTACT_DEALER } from '../constants';

const PriceAndAvailability = ({ item }) => {
  const { partNumber, isPriceLoading, isPriceCall } = item;
  const isLG = useBreakpoint(PAGE_BREAKPOINTS.LG);
  const [t] = useTranslation();
  const totalPrice = useSelector(
    s => s.products.priceAndAvailability?.[partNumber]?.totalPrice
  );
  const coreCharges = useSelector(
    s => s.products?.priceAndAvailability?.[partNumber]?.coreCharges
  );
  const currency = useSelector(s => s.dealerCustomer?.currency);
  const stockAvailability = useSelector(
    s => s.products?.priceAndAvailability?.[partNumber]?.availability?.[0]
  );

  const stock = stockAvailability?.availabilityMessage;
  const popperOptions = {
    placement: 'bottom',
    modifiers: [{ name: 'offset', options: { offset: [0, 8] } }]
  };
  const initiator = (
    <AlloyButton buttonType="link" className="p-0 text-decoration-none">
      <span className="u-color--MediumBlue u-fs--12 p-0">
        {t('CAT_CORE_DEPOSIT_TITLE')}:
      </span>
    </AlloyButton>
  );

  const getDealerInitiator = () => (
    <AlloyButton buttonType="link" className="p-0 text-start">
      {t('CONTACT_YOUR_DEALER')}
    </AlloyButton>
  );

  const getDealerInitiatorButton = () => (
    <div className={isLG ? 'text-end' : 'text-start'}>
      <AlloyButton buttonType="secondary">
        {t('CONTACT_YOUR_DEALER')}
      </AlloyButton>
    </div>
  );

  const showContactDealerButton = () => (
    <Popup
      contents={<ContactDealerPopup partNumber={partNumber} />}
      initiator={getDealerInitiatorButton()}
      popperOptions={popperOptions}
    />
  );

  const showContactDealer = () => (
    <Popup
      contents={<ContactDealerPopup partNumber={partNumber} />}
      initiator={getDealerInitiator()}
      popperOptions={popperOptions}
    />
  );
  const toShowStock = stock === CONTACT_DEALER ? showContactDealer() : stock;

  const showPriceAvailabiltyData = () => {
    if (totalPrice) {
      return (
        <div>
          <p className="mb-0 u-fs--16 fw-bold u-color--ExtraDarkGray">
            {totalPrice}{' '}
            <span className="d-md-none u-color--ExtraDarkGray">{`(${currency})`}</span>
          </p>
          <div className="d-flex">
            <AlloyIcon
              data-testid="info_icon"
              className="u-fill-icon--DarkGrey me-1"
              icon="icon-info"
              height={15}
              width={15}
            />
            <div className="d-flex flex-wrap">
              <CoreDepositPopup
                initiator={initiator}
                popperOptions={popperOptions}
              />
              <span className="u-fs--12 ms-1">{coreCharges}</span>
            </div>
          </div>
          <p className="u-fs--14 mb-0 mt-1">{toShowStock}</p>
        </div>
      );
    } else {
      return showContactDealerButton();
    }
  };

  return (
    <Conditional
      fallback={<InlineLoader className="col-12 col-lg-auto" />}
      test={!isPriceLoading}
    >
      <div> {isPriceCall ? showPriceAvailabiltyData() : null} </div>
    </Conditional>
  );
};

export default PriceAndAvailability;

PriceAndAvailability.propTypes = {
  item: PropTypes.shape({
    partNumber: PropTypes.string,
    isPriceCall: PropTypes.bool,
    isPriceLoading: PropTypes.bool
  })
};
